import { useIntl } from 'react-intl';
import { useEffect } from 'react';

import { OrderAheadProvider } from '@ocx/graphql';
import { ScreenLoader } from '@ocx/ui';
import { useGetNavigationActions } from '@ocx-app/hooks/useGetNavigationActions';
import { useSnackbar } from '@ocx-app/lib/snackbar/snackbar';

import { messages } from './order-ahead-provider.lula.messages';
import { useIframeUrl } from '../../use-iframe-url.hook';
import { useLulaStorage } from './use-lula-storage.hook';

export const OrderAheadProviderLula = () => {
  const intl = useIntl();
  const { replaceToHome } = useGetNavigationActions();
  const snackbar = useSnackbar();
  const { iframeUrl, isLoading, error } = useIframeUrl({ provider: OrderAheadProvider.Lula });
  const { iframeUrlWithPath } = useLulaStorage({ iframeUrl });

  useEffect(() => {
    if (error && !iframeUrl) {
      snackbar.open(intl.formatMessage(messages['order-ahead.lula.loading-iframe-url.error-message']), {
        variant: 'error',
      });
      replaceToHome();
    }
  }, [error, iframeUrl, intl, replaceToHome, snackbar]);

  if (isLoading) {
    return <ScreenLoader />;
  }

  // Case when the iframe URL is not available
  // handled in useEffect
  if (!iframeUrl || !iframeUrlWithPath) return null;
  return <iframe title="Order Ahead" src={iframeUrlWithPath} height="100%" width="100%" style={{ border: 'none' }} />;
};
